// Mock data for stays and hosts

export const getFeaturedDestinations = () => [
  {
    id: 1,
    name: 'Bwindi Impenetrable National Park',
    slug: 'bwindi',
    description: 'Experience the majesty of mountain gorillas in their natural habitat',
    image: 'https://images.unsplash.com/photo-1551033406-611cf9a28f67?w=800&q=80',
    stays: 42,
    priceRange: '80,000 - 500,000',
    rating: 4.8,
  },
  {
    id: 2,
    name: 'Queen Elizabeth National Park',
    slug: 'queen-elizabeth',
    description: 'Witness the famous tree-climbing lions and diverse wildlife',
    image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
    stays: 38,
    priceRange: '60,000 - 400,000',
    rating: 4.7,
  },
  {
    id: 3,
    name: 'Murchison Falls National Park',
    slug: 'murchison',
    description: 'See the Nile River explosively force through a narrow gorge',
    image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80',
    stays: 35,
    priceRange: '70,000 - 450,000',
    rating: 4.6,
  },
  {
    id: 4,
    name: 'Kibale National Park',
    slug: 'kibale',
    description: 'Track chimpanzees and explore the primate capital of the world',
    image: 'https://images.unsplash.com/photo-1540573133985-87b6da6d54a9?w=800&q=80',
    stays: 28,
    priceRange: '50,000 - 350,000',
    rating: 4.8,
  },
  {
    id: 5,
    name: 'Kidepo Valley National Park',
    slug: 'kidepo',
    description: 'Uganda\'s most remote wilderness with authentic African savanna',
    image: 'https://images.unsplash.com/photo-1535338454770-6c4f504d5f6b?w=800&q=80',
    stays: 18,
    priceRange: '40,000 - 300,000',
    rating: 4.9,
  },
  {
    id: 6,
    name: 'Lake Mburo National Park',
    slug: 'lake-mburo',
    description: 'Zebras, impalas, and water buffalo in Uganda\'s biggest game reserve',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
    stays: 22,
    priceRange: '55,000 - 320,000',
    rating: 4.5,
  },
]

export const getHostSpotlights = () => [
  {
    id: 1,
    name: 'Grace\'s Forest Homestay',
    property: 'Grace\'s Forest Homestay',
    location: 'Bwindi Impenetrable',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    quote: 'Cozy homestay experience with warm hospitality. Perfect for budget-conscious travelers seeking an authentic stay near gorilla trekking sites.',
    rating: 5,
    reviews: 87,
    womenLed: true,
    ecocertified: true,
    newHost: false,
  },
  {
    id: 2,
    name: 'Kibale Chimp Lodge',
    property: 'Kibale Chimp Lodge',
    location: 'Kibale National Park',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
    quote: 'Mid-range lodge with expert guides and excellent amenities. Ideal for travelers seeking quality accommodation and immersive safari experiences.',
    rating: 5,
    reviews: 124,
    womenLed: false,
    ecocertified: true,
    newHost: false,
  },
  {
    id: 3,
    name: 'Sisters\' Safari Eco-Camp',
    property: 'Sisters\' Safari Eco-Camp',
    location: 'Queen Elizabeth National Park',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
    quote: 'Premium eco-camp offering luxury accommodations and exceptional service. Perfect for discerning travelers looking for comfort and sustainability.',
    rating: 4.9,
    reviews: 156,
    womenLed: true,
    ecocertified: true,
    newHost: false,
  },
  {
    id: 4,
    name: 'Murchison Riverside Camp',
    property: 'Murchison Riverside Camp',
    location: 'Murchison Falls',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    quote: 'Established riverside accommodation with premium amenities and full-service facilities. Highly rated for travelers seeking comfort and convenience.',
    rating: 4.8,
    reviews: 98,
    womenLed: false,
    ecocertified: false,
    newHost: false,
  },
  {
    id: 5,
    name: 'Kidepo Nomad Tents',
    property: 'Kidepo Nomad Tents',
    location: 'Kidepo Valley',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
    quote: 'Unique glamping experience in remote wilderness. Ideal for adventure seekers wanting authentic accommodations in Uganda\'s most pristine safari region.',
    rating: 4.9,
    reviews: 67,
    womenLed: true,
    ecocertified: true,
    newHost: true,
  },
]

export const getAllStays = () => [
  // Bwindi stays
  {
    id: 1,
    name: 'Grace\'s Forest Homestay',
    destination: 'bwindi',
    location: 'Bwindi Impenetrable National Park',
    propertyType: 'Homestay',
    image: 'https://images.unsplash.com/photo-1578049635882-6e82b35bac80?w=500&q=80',
    hostName: 'Grace\'s Forest Homestay',
    hostImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&q=80',
    pricePerNight: 120000,
    rating: 5,
    reviews: 87,
    description: 'Budget-friendly homestay accommodation with comfortable rooms and included meals. Features hot water, WiFi, and local guide services for gorilla trekking activities.',
    amenities: ['Hot Water', 'Meals Included', 'Guides Available', 'WiFi'],
    maxGuests: 4,
    bedrooms: 2,
    isFeatured: true,
    ecocertified: true,
    womenLed: true,
    availableUntil: '5 spots',
  },
  {
    id: 2,
    name: 'Misty Gorilla Lodge',
    destination: 'bwindi',
    location: 'Bwindi Impenetrable National Park',
    propertyType: 'Lodge',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&q=80',
    hostName: 'Misty Gorilla Lodge',
    hostImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80',
    pricePerNight: 280000,
    rating: 4.8,
    reviews: 62,
    description: 'Mid-range lodge with excellent amenities including swimming pool, professional guides, and full meal service. Perfect for travelers seeking quality comfort.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available'],
    maxGuests: 8,
    bedrooms: 4,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: '8 spots',
  },
  {
    id: 3,
    name: 'Bwindi Eco-Cabins',
    destination: 'bwindi',
    location: 'Bwindi Impenetrable National Park',
    propertyType: 'Eco-Cabin',
    image: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=500&q=80',
    hostName: 'Bwindi Eco-Cabins',
    hostImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50&q=80',
    pricePerNight: 180000,
    rating: 4.9,
    reviews: 45,
    description: 'Eco-friendly cabins with excellent amenities. Offers hot water, meal services, guided tours, and beautiful garden setting. Mid-range pricing for eco-conscious travelers.',
    amenities: ['Hot Water', 'Meals Included', 'Guides Available', 'Garden'],
    maxGuests: 6,
    bedrooms: 3,
    isFeatured: true,
    ecocertified: true,
    womenLed: false,
    availableUntil: '3 spots',
  },
  {
    id: 4,
    name: 'Gorilla Haven Tented Camp',
    destination: 'bwindi',
    location: 'Bwindi Impenetrable National Park',
    propertyType: 'Tented Camp',
    image: 'https://images.unsplash.com/photo-1432405972618-c60b0b0c201d?w=500&q=80',
    hostName: 'Gorilla Haven Tented Camp',
    hostImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&q=80',
    pricePerNight: 150000,
    rating: 4.7,
    reviews: 38,
    description: 'Glamping experience with spacious safari tents and en-suite facilities. Includes hot water, WiFi, guide services, and parking. Excellent value for adventure travelers.',
    amenities: ['Hot Water', 'Guides Available', 'WiFi', 'Parking'],
    maxGuests: 5,
    bedrooms: 2,
    isFeatured: false,
    ecocertified: false,
    womenLed: false,
    availableUntil: null,
  },

  // Queen Elizabeth stays
  {
    id: 5,
    name: 'Sisters\' Safari Eco-Camp',
    destination: 'queen-elizabeth',
    location: 'Queen Elizabeth National Park',
    propertyType: 'Eco-Cabin',
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=500&q=80',
    hostName: 'Sisters\' Safari Eco-Camp',
    hostImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50&q=80',
    pricePerNight: 200000,
    rating: 4.9,
    reviews: 156,
    description: 'Premium eco-camp with comprehensive amenities including swimming pool, meals, guides, and hot water. Spacious accommodation with excellent service and activities.',
    amenities: ['Hot Water', 'Meals Included', 'Guides Available', 'Swimming Pool'],
    maxGuests: 12,
    bedrooms: 6,
    isFeatured: true,
    ecocertified: true,
    womenLed: true,
    availableUntil: '2 spots',
  },
  {
    id: 6,
    name: 'Kazinga Channel Tented Resort',
    destination: 'queen-elizabeth',
    location: 'Queen Elizabeth National Park',
    propertyType: 'Tented Camp',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&q=80',
    hostName: 'Kazinga Channel Tented Resort',
    hostImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80',
    pricePerNight: 250000,
    rating: 4.6,
    reviews: 92,
    description: 'Premium waterfront tented accommodation with full amenities including WiFi, swimming pool, meals, and guides. Excellent for boat safaris and wildlife activities.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available'],
    maxGuests: 10,
    bedrooms: 5,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: null,
  },
  {
    id: 7,
    name: 'Lion View Homestay',
    destination: 'queen-elizabeth',
    location: 'Queen Elizabeth National Park',
    propertyType: 'Homestay',
    image: 'https://images.unsplash.com/photo-1578049635882-6e82b35bac80?w=500&q=80',
    hostName: 'Lion View Homestay',
    hostImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50&q=80',
    pricePerNight: 100000,
    rating: 4.5,
    reviews: 41,
    description: 'Budget-friendly homestay with homemade meals and warm hospitality. Includes hot water, parking, and garden. Excellent value accommodation.',
    amenities: ['Hot Water', 'Meals Included', 'Garden', 'Parking'],
    maxGuests: 6,
    bedrooms: 3,
    isFeatured: false,
    ecocertified: false,
    womenLed: true,
    availableUntil: '4 spots',
  },

  // Kibale stays
  {
    id: 8,
    name: 'Kibale Chimp Lodge',
    destination: 'kibale',
    location: 'Kibale National Park',
    propertyType: 'Lodge',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&q=80',
    hostName: 'Kibale Chimp Lodge',
    hostImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80',
    pricePerNight: 220000,
    rating: 5,
    reviews: 124,
    description: 'Mid-range lodge with excellent facilities including WiFi, meals, guides, and parking. Highly rated for quality service and comfortable accommodation.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Guides Available', 'Parking'],
    maxGuests: 10,
    bedrooms: 5,
    isFeatured: true,
    ecocertified: true,
    womenLed: false,
    availableUntil: null,
  },
  {
    id: 9,
    name: 'Primate Sanctuary Guest House',
    destination: 'kibale',
    location: 'Kibale National Park',
    propertyType: 'Guest House',
    image: 'https://images.unsplash.com/photo-1578049635882-6e82b35bac80?w=500&q=80',
    hostName: 'Primate Sanctuary Guest House',
    hostImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&q=80',
    pricePerNight: 160000,
    rating: 4.8,
    reviews: 55,
    description: 'Mid-range guest house with full amenities including hot water, WiFi, meals, and guides. Well-maintained facility offering good value for travelers.',
    amenities: ['Hot Water', 'Meals Included', 'Guides Available', 'WiFi'],
    maxGuests: 8,
    bedrooms: 4,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: '2 spots',
  },

  // Murchison Falls stays
  {
    id: 10,
    name: 'Murchison Riverside Camp',
    destination: 'murchison',
    location: 'Murchison Falls National Park',
    propertyType: 'Tented Camp',
    image: 'https://images.unsplash.com/photo-1432405972618-c60b0b0c201d?w=500&q=80',
    hostName: 'Murchison Riverside Camp',
    hostImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&q=80',
    pricePerNight: 280000,
    rating: 4.8,
    reviews: 98,
    description: 'Premium riverside accommodation with comprehensive amenities including swimming pool, WiFi, meals, guides, and hot water. Excellent for Nile activities.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available'],
    maxGuests: 12,
    bedrooms: 6,
    isFeatured: true,
    ecocertified: false,
    womenLed: false,
    availableUntil: null,
  },
  {
    id: 11,
    name: 'Nile Falls Lodge',
    destination: 'murchison',
    location: 'Murchison Falls National Park',
    propertyType: 'Lodge',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&q=80',
    hostName: 'Nile Falls Lodge',
    hostImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80',
    pricePerNight: 320000,
    rating: 4.7,
    reviews: 76,
    description: 'Luxury lodge with premium amenities including swimming pool, WiFi, spa, meals, guides, and parking. High-end accommodation for discerning travelers.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available', 'Parking'],
    maxGuests: 14,
    bedrooms: 7,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: '1 spot',
  },

  // Kidepo Valley stays
  {
    id: 12,
    name: 'Kidepo Nomad Tents',
    destination: 'kidepo',
    location: 'Kidepo Valley National Park',
    propertyType: 'Tented Camp',
    image: 'https://images.unsplash.com/photo-1432405972618-c60b0b0c201d?w=500&q=80',
    hostName: 'Kidepo Nomad Tents',
    hostImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50&q=80',
    pricePerNight: 180000,
    rating: 4.9,
    reviews: 67,
    description: 'Unique glamping experience in remote wilderness. Includes hot water, meals, guides, and garden. Perfect for adventure-seeking travelers in Uganda\'s most pristine region.',
    amenities: ['Hot Water', 'Meals Included', 'Guides Available', 'Garden'],
    maxGuests: 8,
    bedrooms: 4,
    isFeatured: true,
    ecocertified: true,
    womenLed: true,
    availableUntil: '6 spots',
  },
  {
    id: 13,
    name: 'Apoka Safari Lodge',
    destination: 'kidepo',
    location: 'Kidepo Valley National Park',
    propertyType: 'Lodge',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&q=80',
    hostName: 'Apoka Safari Lodge',
    hostImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&q=80',
    pricePerNight: 240000,
    rating: 4.9,
    reviews: 52,
    description: 'Premium lodge with full amenities including swimming pool, WiFi, meals, guides, and hot water. Highly rated for service quality and comfort.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available'],
    maxGuests: 10,
    bedrooms: 5,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: null,
  },

  // Lake Mburo stays
  {
    id: 14,
    name: 'Mburo Lakeside Eco-Resort',
    destination: 'lake-mburo',
    location: 'Lake Mburo National Park',
    propertyType: 'Resort',
    image: 'https://images.unsplash.com/photo-1546899402-a5dbe6d01220?w=500&q=80',
    hostName: 'Mburo Lakeside Eco-Resort',
    hostImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=50&q=80',
    pricePerNight: 200000,
    rating: 4.8,
    reviews: 89,
    description: 'Premium waterfront resort with full amenities including swimming pool, WiFi, meals, guides, and parking. Excellent for boat safaris and wildlife activities.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Swimming Pool', 'Guides Available', 'Parking'],
    maxGuests: 12,
    bedrooms: 6,
    isFeatured: true,
    ecocertified: true,
    womenLed: true,
    availableUntil: '3 spots',
  },
  {
    id: 15,
    name: 'Zebra Plains Lodge',
    destination: 'lake-mburo',
    location: 'Lake Mburo National Park',
    propertyType: 'Lodge',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=500&q=80',
    hostName: 'Zebra Plains Lodge',
    hostImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&q=80',
    pricePerNight: 220000,
    rating: 4.7,
    reviews: 71,
    description: 'Mid-range lodge with excellent amenities including WiFi, hot water, meals, guides, and parking. Professional service and great value for game viewing.',
    amenities: ['WiFi', 'Hot Water', 'Meals Included', 'Guides Available', 'Parking'],
    maxGuests: 10,
    bedrooms: 5,
    isFeatured: false,
    ecocertified: true,
    womenLed: false,
    availableUntil: null,
  },
]
